import { useNavigate } from 'react-router-dom';
import { C } from '../constants';
import FontStyles from './FontStyles';
import SiteFooter from './SiteFooter';
import SubscribeCTA from './SubscribeCTA';
import SiteHeader from './SiteHeader';

export default function StaticPageWrapper({ children }) {
  const navigate = useNavigate();

  const voteNow = (
    <button
      onClick={() => navigate('/')}
      style={{
        background: '#D32F2F', border: 'none',
        padding: '6px 16px', borderRadius: 999, fontSize: '0.73rem',
        fontWeight: 600, color: '#fff', cursor: 'pointer',
        fontFamily: "'Poppins', sans-serif", letterSpacing: '0.04em',
        whiteSpace: 'nowrap', marginLeft: 4,
      }}
    >
      Vote Now
    </button>
  );

  return (
    <div
      style={{
        background:      C.bg,
        minHeight:       '100vh',
        color:           C.white,
        fontFamily:      "'Poppins', sans-serif",
        backgroundImage:
          'radial-gradient(ellipse at 0% 0%, rgba(0,229,255,0.10) 0%, transparent 45%), ' +
          'radial-gradient(ellipse at 100% 100%, rgba(255,77,158,0.10) 0%, transparent 45%), ' +
          'radial-gradient(ellipse at 50% 30%, rgba(120,90,255,0.06) 0%, transparent 50%)',
        backgroundAttachment: 'fixed',
      }}
    >
      <FontStyles />
      <SiteHeader right={voteNow} />

      {/* Content */}
      <div className="relative z-10">{children}</div>

      <SubscribeCTA
        theme="dark"
        title="Stay Updated"
        subtitle="Get notified when new state elections go live."
        source="home"
      />
      <SiteFooter />
    </div>
  );
}
